export default "__VITE_ASSET__049137de__"